import { ArrowLeftOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import { withFormik } from 'formik'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../../Components/Button'
import Field from '../../../../Components/Formik/Field'
import Form from '../../../../Components/Formik/Form'
import Panel from '../../../../Layout/Panel'
import PanelLayout from '../../../../Layout/PanelLayout'
import apiClient from '../../../../Util/apiClient'
import { STATUS } from '../../../../Util/Options'
import { POLPODSchema } from '../../../../Util/validationSchema'

function POLPODForm({
  values,
  setValues,
  match: {
    params: { id }
  }
}) {
  const getData = () => {
    if (id) {
      apiClient.get(`pol-pod/${id}`).then(({ status, data }) => {
        if (status === 200) {
          setValues({ ...values, ...data })
        }
      })
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <Form>
      <Row justify="center" className="inner-contents">
        <Col xs={22} sm={22} md={20} lg={20}>
          <PanelLayout title="POL/POD Definition">
            <Panel title="POL/POD">
              <Row gutter={[20, 10]}>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field name="code" label="Code" />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field name="description" label="Description" />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <div className="form-field">
                    <Field as="select" name="status" label="Status" options={STATUS} />
                  </div>
                </Col>
              </Row>
            </Panel>
          </PanelLayout>
          <div className="save-changes">
            <Button type="submit" variant="primary">
              {id ? 'Update' : 'Save'}
            </Button>
            <span>or</span>
            <Link to="/app/pol-pod">
              <Button>
                <ArrowLeftOutlined /> Back to POD/POL
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues: () => ({
    code: '',
    description: '',
    status: 'Active'
  }),
  validationSchema: POLPODSchema,
  handleSubmit: (
    data,
    {
      props: {
        match: {
          params: { id }
        },
        history
      }
    }
  ) => {
    if (id) {
      apiClient.put(`pol-pod/${id}`, data).then(({ status }) => {
        if (status === 200) {
          history.push('/app/pol-pod')
        }
      })
    } else {
      apiClient.post('pol-pod', data).then(({ status }) => {
        if (status === 201) {
          history.push('/app/pol-pod')
        }
      })
    }
  }
})(POLPODForm)
